<template lang="pug">
.chart-preview.pa-5
  v-row
    v-col.d-flex.align-center
      v-container.pa-0
        v-row
          v-col
            h2.primary--text {{ $t('Chart.preview') }}
        v-row
          v-col
            template(v-if="loading")
              v-skeleton-loader(type="article")
            template(v-else)
              GChart(
                v-if="chartType && data && config",
                :type="chartType",
                :options="config",
                :settings="{ packages: ['corechart', 'gauge', 'table'] }",
                v-bind="{ data }",
              )
    v-col.d-flex(cols="auto")
      v-row.py-3.flex-column
        g-btn.advanced-keys.background.h9.primary--text.ma-1(
          height="38px",
          width="200px",
          @click="loadPreview"
        ) {{ $t('Chart.mockPreview') }}
        g-btn.advanced-keys.background.h9.primary--text.ma-1(
          height="38px",
          width="200px",
          @click="loadPreviewData"
        ) {{ $t('Chart.previewData') }}
</template>

<script>
import { GChart } from 'vue-google-charts';
import axios from 'axios';
import EntityMixin from '@/mixins';

export default {
  mixins: [EntityMixin],
  props: {
    chartType: {
      type: String,
    },
    config: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    GChart,
  },
  data: () => ({
    loading: false,
    data: null,
    dataMock: [
        [
            "Element",
            "Density",
            "Value",
        ],
        [
            "Copper",
            8.94,
            5,
        ],
        [
            "Silver",
            10.49,
            10,
        ],
        [
            "Gold",
            19.30,
            23,
        ],
        [
            "Platinum",
            21.45,
            41,
        ]
    ],
    /*
    dataMockGeoChart: [
        [
            "Country",
            "Popularity"
        ],
        [
            "South America",
            600
        ],
        [
            "Brazile",
            500
        ],
        [
            "France",
            600
        ],
        [
            "Russia",
            700
        ],
        [
            "Australia",
            600
        ]
    ],
    */
    /*
    dataMockTreeMap: [
      ['Location', 'Parent', 'Market trade volume (size)', 'Market increase/decrease (color)'],
      ['Global',    null,                 0,                               0],
      ['America',   'Global',             0,                               0],
      ['Europe',    'Global',             0,                               0],
      ['Asia',      'Global',             0,                               0],
      ['Australia', 'Global',             0,                               0],
      ['Africa',    'Global',             0,                               0],
      ['Brazil',    'America',            11,                              10],
      ['USA',       'America',            52,                              31],
      ['Mexico',    'America',            24,                              12],
      ['Canada',    'America',            16,                              -23],
      ['France',    'Europe',             42,                              -11],
      ['Germany',   'Europe',             31,                              -2],
      ['Sweden',    'Europe',             22,                              -13],
      ['Italy',     'Europe',             17,                              4],
      ['UK',        'Europe',             21,                              -5],
      ['China',     'Asia',               36,                              4],
      ['Japan',     'Asia',               20,                              -12],
      ['India',     'Asia',               40,                              63],
      ['Laos',      'Asia',               4,                               34],
      ['Mongolia',  'Asia',               1,                               -5],
      ['Israel',    'Asia',               12,                              24],
      ['Iran',      'Asia',               18,                              13],
      ['Pakistan',  'Asia',               11,                              -52],
      ['Egypt',     'Africa',             21,                              0],
      ['S. Africa', 'Africa',             30,                              43],
      ['Sudan',     'Africa',             12,                              2],
      ['Congo',     'Africa',             10,                              12],
      ['Zaire',     'Africa',             8,                               10]
    ],
    */
  }),
  methods: {
    async loadPreview() {
      try {
        this.loading = true;
        console.log('LOAD Preview');
        this.data = this.dataMock;
      } catch(e) {
        console.log(this.$cleanString(e));
      } finally {
        this.loading = false;
      }
    },
    async loadPreviewData() {
      try {
        this.loading = true;

        const configJSON = JSON.stringify({ options: this.config, type: this.chartType });
        const copyInstance = _.cloneDeep(this.instance);
        copyInstance.config = configJSON;

        const preview = (await axios.post('dashboards/preview', copyInstance)).data
        this.data = preview;
      } catch(e) {
        console.log(this.$cleanString(e));
      } finally {
        this.loading = false;
      }
    },
  },
}
</script>
